"use strict";
exports.__esModule = true;
var FlexView_1 = require("./FlexView");
exports["default"] = FlexView_1.FlexView;
